require('es6-promise').polyfill();
import Vue from 'vue';
import fetch from '@/common/util/fetch';

import {
    Actionsheet,
    Button,
    Cell,
    DatetimePicker,
    Field,
    Lazyload,
    MessageBox,
    Popup,
    Progress,
    Radio,
    Spinner,
    Swipe,
    SwipeItem,
    Switch,
    Toast,
    Picker,
    Indicator,
    Range,
    InfiniteScroll
} from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.component(Actionsheet.name, Actionsheet);
Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Field.name, Field);
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);
Vue.component(Progress.name, Progress);
Vue.component(Radio.name, Radio);
Vue.component(Spinner.name, Spinner);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Switch.name, Switch);
Vue.component(Progress.name, Progress);
Vue.component(Range.name, Range);
Vue.use(Lazyload);
Vue.use(InfiniteScroll);
import App from './App';
import router from './router';
import store from './vuex/store';
import vueEventCalendar from 'vue-event-calendar';
// import 'vue-event-calendar/dist/style.css';
import '@/assets/style/calendarStyle.css';
Vue.use(vueEventCalendar, {locale: 'zh', color: '#fd8b23'});
Vue.prototype.$toast = Toast;
Vue.prototype.$messageBox = MessageBox;
Vue.prototype.$indicator = Indicator;
Vue.prototype.$axios = fetch;
Vue.config.productionTip = false
// net listener
import * as NetWork from '@/common/util/network.js';
NetWork.offLineLister();

const dateFilter = function (value, fmt) {
    if (value) {
        let date = new Date(value * 1000);
        var o = {
            "M+": date.getMonth() + 1,                 //月份
            "d+": date.getDate(),                    //日
            "h+": date.getHours(),                   //小时
            "m+": date.getMinutes(),                 //分
            "s+": date.getSeconds(),                 //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    } else {
        return '   -'
    }
}

import { isAndroid } from '@/common/util/global';
router.beforeEach((to, from, next) => {
    if (isAndroid) {
        // android 需要每次都赋予当前的值
        store.state.baseUrl.url = location.origin + to.fullPath
    }
    next();
});

Vue.prototype.$dateFilter = dateFilter
Vue.filter('dateFilter', dateFilter)

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js